import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  deleteSituationsApiCrud,
  type DeleteSituationsRequest,
} from "@/generated/fastapi";

export async function deleteSituations(
  accessToken: string | null | undefined,
  request: DeleteSituationsRequest,
) {
  const response = await deleteSituationsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to delete situations (${response.status})`);
  }

  return response.data;
}
